import { ISelectOptions } from "../../../types/inputs";
import { Button } from "../../Atoms/Button";
import { SimpleSelect } from "../../Atoms/Selects/SimpleSelect";
import { LayoutTemplate } from "../../Templates/LayoutTemplate";
import * as S from "./styles";
import { useProductivityServiceByClient } from "./useProductivityServiceByClient";
export const ProductivityServiceByClient = () => {
  const {
    mothOptions,
    yearOptions,
    filter,
    setFilter,
    empresasOptions,
    lojasOptions,
    handleFilter,
    producao,
    handleDownDoc,
  } = useProductivityServiceByClient();
  return (
    <LayoutTemplate title="Relatório de Produção por Tipo de Cliente">
      <S.Container>
        <S.FormReconciliationReport onSubmit={handleFilter}>
          <div>
            <label>Mês</label>
            <SimpleSelect
              isClearable
              options={mothOptions}
              value={mothOptions.find((i) => +i.value === filter?.mes) || null}
              onChange={(e: ISelectOptions) => {
                e
                  ? setFilter((prev) => ({ ...prev, mes: +e.value }))
                  : setFilter((prev) => ({ ...prev, mes: null }));
              }}
            />
          </div>

          <div>
            <label>Ano</label>
            <SimpleSelect
              isClearable
              value={yearOptions.find((i) => i.value === filter.ano) || null}
              onChange={(e: ISelectOptions) =>
                e
                  ? setFilter((prev) => ({ ...prev, ano: e.value }))
                  : setFilter((prev) => ({ ...prev, ano: null }))
              }
              options={yearOptions}
            />
          </div>

          <div>
            <label>Empresa</label>
            <SimpleSelect
              isClearable
              value={
                empresasOptions.find((i) => i.value === filter.empresa) || null
              }
              onChange={(e: ISelectOptions) =>
                e
                  ? setFilter((prev) => ({ ...prev, empresa: e.value }))
                  : setFilter((prev) => ({ ...prev, empresa: null }))
              }
              options={empresasOptions}
            />
          </div>

          <div>
            <label>Loja</label>
            <SimpleSelect
              isClearable
              value={
                lojasOptions.find((i) => i.value === filter.cidade) || null
              }
              onChange={(e: ISelectOptions) =>
                e
                  ? setFilter((prev) => ({ ...prev, cidade: e.value }))
                  : setFilter((prev) => ({ ...prev, cidade: null }))
              }
              options={lojasOptions}
            />
          </div>

          <div>
            <Button>Filtrar</Button>
          </div>
        </S.FormReconciliationReport>
        <S.Table>
          <S.TableHead>
            <tr>
              <td className="fixeSize" rowSpan={3}>
                Empresa
              </td>
              <td className="fixeSize" rowSpan={3}>
                Loja
              </td>
              <td colSpan={2}>Concessionária</td>
              <td colSpan={2}>Despachante</td>

              <td colSpan={2}>Lojista</td>
              <td colSpan={2}>Particular</td>
            </tr>

            <tr>
              <td className="textSmall fixeSize bg-orange">Qtd.</td>
              <td className="textSmall fixeSize bg-orange">%</td>

              <td className="textSmall fixeSize bg-orange">Qtd.</td>
              <td className="textSmall fixeSize bg-orange">%</td>

              <td className="textSmall fixeSize bg-orange">Qtd.</td>
              <td className="textSmall fixeSize bg-orange">%</td>

              <td className="textSmall fixeSize bg-orange">Qtd.</td>
              <td className="textSmall fixeSize bg-orange">%</td>
            </tr>
          </S.TableHead>
          <S.TableBody>
            {producao.producaoUnidadeTipoClienteList?.map((prod, index) => (
              <tr key={index}>
                <td>{prod.empresa}</td>
                <td>{prod.unidade}</td>

                <td>{prod.qtdConcessionaria}</td>
                <td>{prod.perConcessionaria}%</td>

                <td>{prod.qtdDespachante}</td>
                <td>{prod.perDespachante}%</td>

                <td>{prod.qtdLojista}</td>
                <td>{prod.perLojista}%</td>

                <td>{prod.qtdParticular}</td>
                <td>{prod.perParticular}%</td>
              </tr>
            ))}
          </S.TableBody>
        </S.Table>

        <S.GridContainer>
          <S.RankingContainer>
            <S.RankingHeader>
              <div>
                <h2>Ranking</h2>
                <p>dos principais clientes</p>
              </div>
            </S.RankingHeader>

            <S.RankingContent>
              <S.RankingContent>
                {producao.clienteRankingList
                  ?.slice()
                  .sort(
                    (a, b) => b.quantidade_vistorias - a.quantidade_vistorias
                  )
                  .map((cliente, index) => {
                    return (
                      <S.RankingItem
                        key={cliente.cpf_cnpj}
                        className={index === 0 ? "first-position" : ""}
                      >
                        <p>
                          <img
                            src="/assets/svg/icon-medal-star.svg"
                            alt="icone medalha"
                          />
                          {cliente.nome_cliente}
                        </p>
                        <span>{cliente.quantidade_vistorias} vistorias</span>
                      </S.RankingItem>
                    );
                  })}
              </S.RankingContent>
            </S.RankingContent>
          </S.RankingContainer>

          <S.RankingContainer>
            <S.TitleSection>Relatórios</S.TitleSection>

            <div>
              <S.ButtonDocDown onClick={handleDownDoc}>
                <S.WrapperImgButton>
                  <img src="/assets/svg/icon-doc.svg" alt="icone-doc" />
                </S.WrapperImgButton>
                <span>Produção por Despachante</span>
                <S.WrapperImgButton>
                  <img
                    src="/assets/svg/icon-arrowdown-white.svg"
                    alt="icone seta"
                  />
                </S.WrapperImgButton>
              </S.ButtonDocDown>
            </div>
          </S.RankingContainer>
        </S.GridContainer>
      </S.Container>
    </LayoutTemplate>
  );
};
